import { useTranslation } from 'react-i18next'

interface MetaProps {
  title: string
  description?: string
}

export const Meta = ({ title, description }: MetaProps) => {
  const { t } = useTranslation()

  return (
    <>
      <title>{`${title} ${t('meta.title.suffix')}`}</title>
      {description && <meta name="description" content={description} />}
    </>
  )
}
